import React, { useState } from 'react';
import { exportToExcel } from 'src/utils/Common';
import { Button } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useTranslation } from 'react-i18next';

function MaterialExcelExport(JsonData) {
  const { t } = useTranslation('overview');

  if (JsonData?.JsonData?.length === 0) {
    return (
      <Button
        size="small"
        variant="contained"
        color="primary"
        disabled={true}
        fullWidth
        endIcon={<CloudDownloadIcon />}
      >
        {t('lblExport')}
      </Button>
    )
  }


  var ExportData = JsonData.JsonData.map(item => {
    return {
      WorkCaseId: item.WorkCaseId,
      WorkOrderId: item.id,
      ServiceCode: item.ServiceCode,
      ServiceShop: item.ServiceShop,
      WarrantyType: item.WarrantyType,
      CallCenterNote: item.CallCenterNote,
      Brand: item.Brand,
      ProductCode: item.ProductCode,
      Product: item.Product,
      CallDate: item.CallDate,
      IssueReason: item.IssueReason,
      CreateUser: item.CreateUser,
      UpdateUser: item.UpdateUser,
      Technician: item.Technician,
      Customer: item.Customer,
      LabourPrice: item.LabourPrice,
      MaterialPrice: item.MaterialPrice,
      TransportPrice: item.TransportPrice,
      ExtraPrice: item.ExtraPrice,
      TotalPrice: item.TotalPrice,
      CreateUser: item.CreateUser,
      UpdateUser: item.UpdateUser
    }
  });


  return (
    // <ExcelFile element={
    //   <Button
    //     size="small"
    //     variant="contained"
    //     color="primary"
    //     fullWidth
    //     endIcon={<CloudDownloadIcon />}
    //   >
    //     {t('lblExport')}
    //   </Button>}>
    //   <ExcelSheet data={ExportData} name="TaskManagement">
    //     <ExcelColumn label={t('WorkCaseId')} value="WorkCaseId" />
    //     <ExcelColumn label={t('WorkOrderId')} value="WorkOrderId" />
    //     <ExcelColumn label={t('ServiceCode')} value="ServiceCode" />
    //     <ExcelColumn label={t('ServiceShop')} value="ServiceShop" />
    //     <ExcelColumn label={t('WarrantyType')} value="WarrantyType" />
    //     <ExcelColumn label={t('CallCenterNote')} value="CallCenterNote" />
    //     <ExcelColumn label={t('Brand')} value="Brand" />
    //     <ExcelColumn label={t('ProductCode')} value="ProductCode" />
    //     <ExcelColumn label={t('Product')} value="Product" />
    //     <ExcelColumn label={t('lblCallDate')} value="CallDate" />
    //     <ExcelColumn label={t('Application Type')} value="IssueReason" />
    //     <ExcelColumn label={t('CreateUser')} value="CreateUser" />
    //     <ExcelColumn label={t('UpdateUser')} value="UpdateUser" />
    //     <ExcelColumn label={t('Technician')} value="Technician" />
    //     <ExcelColumn label={t('Customer')} value="Customer" />
    //     <ExcelColumn label={t('Brand')} value="Brand" />
    //     <ExcelColumn label={t('LabourPrice')} value="LabourPrice" />
    //     <ExcelColumn label={t('MaterialPrice')} value="MaterialPrice" />
    //     <ExcelColumn label={t('TransportPrice')} value="TransportPrice" />
    //     <ExcelColumn label={t('ExtraPrice')} value="ExtraPrice" />
    //     <ExcelColumn label={t('TotalPrice')} value="TotalPrice" />
    //     <ExcelColumn label={t('CreateUser')} value="CreateUser" />
    //     <ExcelColumn label={t('UpdateUser')} value="UpdateUser" />
        
    //   </ExcelSheet>

    // </ExcelFile>
    <>
      <Button
        size="small"
       variant="contained"
         color="primary"
         fullWidth
         endIcon={<CloudDownloadIcon />}
         onClick={() => exportToExcel(ExportData, 'TaskManagementExport') }
       >
        {t('lblExport')}
       </Button>
    </>
  );
}

MaterialExcelExport.propTypes = {

};

export default MaterialExcelExport;
